import { isCodeChild } from '../isCodeChild/isCodeChild'

/**
 * Extracts the code from a code block.
 * @param props - The props of the code block.
 * @returns The code of the code block.
 */
export const extractCode = (props: { children: unknown }): string => {
  const { children } = props
  if (typeof children === 'string') {
    return children
  }
  if (isCodeChild(children)) {
    return children.props.children
  }
  return ''
}
